// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"452":"c212cb82","513":"470817c1","548":"cca1842e","750":"267ff76d","822":"03adba50","826":"799a044e"}[chunkId] + ".1790794919743.chunk.js";
};